var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSun = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 25 25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.032.01h-1.55v6.14a5.914 5.914 0 0 0-2.827 1.165L4.322 2.98 3.227 4.076l4.329 4.33a5.915 5.915 0 0 0-1.188 2.83H.258v1.548h6.101a5.914 5.914 0 0 0 1.156 2.843l-4.304 4.305 1.095 1.095 4.296-4.296a5.915 5.915 0 0 0 2.88 1.206v6.073h1.55v-6.073a5.915 5.915 0 0 0 2.865-1.194l4.302 4.302 1.095-1.095-4.306-4.307a5.913 5.913 0 0 0 1.167-2.859h6.102v-1.548h-6.11a5.915 5.915 0 0 0-1.201-2.847l4.333-4.333-1.095-1.095-4.341 4.341a5.914 5.914 0 0 0-2.811-1.153V.01Zm-.775 7.638a4.401 4.401 0 0 1 4.395 4.395 4.401 4.401 0 0 1-4.395 4.395 4.401 4.401 0 0 1-4.395-4.395 4.401 4.401 0 0 1 4.395-4.395Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSun);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Sun.48e26a86408a61f1e24319ecd760f87c.svg";